import { createSlice, createAction, PayloadAction } from "@reduxjs/toolkit";

// Trigger action for saga compatibility (saga watches this)
export const attemptChangePassword = createAction<any>("forgotPassword/trigger");

// External actions this slice responds to
import { logoutStart } from "@/store/slices/auth";
const reactivateAccountStart = createAction("REACTIVATE_ACCOUNT_START");
const reactivateAccountSuccess = createAction("REACTIVATE_ACCOUNT_SUCCESS");
const reactivateAccountFailure = createAction("REACTIVATE_ACCOUNT_FAILURE");

interface ForgotPasswordState {
  message: string | null;
  address: string;
  errors: string[];
  loading: boolean;
  succeeded: boolean;
  failed: boolean;
}

const initialState: ForgotPasswordState = {
  message: null,
  address: "",
  errors: [],
  loading: false,
  succeeded: false,
  failed: false,
};

const forgotPasswordSlice = createSlice({
  name: "forgotPassword",
  initialState,
  reducers: {
    forgotPasswordStart(state) {
      state.loading = true;
      state.succeeded = false;
      state.failed = false;
    },
    forgotPasswordSuccess(state) {
      state.errors = [];
      state.loading = false;
      state.address = "";
      state.message = "Please check your email to reset your password!";
      state.succeeded = true;
      state.failed = false;
    },
    forgotPasswordFailure(state) {
      state.errors = ["Error resetting password. Please make sure the email address is in use."];
      state.loading = false;
      state.succeeded = false;
      state.failed = true;
    },
    forgotPasswordEditEmail(state, action: PayloadAction<{ email: string }>) {
      state.address = action.payload.email;
      state.message = "";
      state.errors = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(reactivateAccountStart, (state) => {
        state.loading = true;
        state.succeeded = false;
        state.failed = false;
      })
      .addCase(reactivateAccountSuccess, (state) => {
        state.errors = [];
        state.loading = false;
        state.message = "To finish reactivating your account, please check your email!";
        state.succeeded = true;
        state.failed = false;
      })
      .addCase(reactivateAccountFailure, (state) => {
        state.errors = ["Error reactivating account. Are you sure the account was deactivated?"];
        state.loading = false;
        state.succeeded = false;
        state.failed = true;
      })
      .addCase(logoutStart, () => ({ ...initialState }));
  },
});

export const {
  forgotPasswordStart,
  forgotPasswordSuccess,
  forgotPasswordFailure,
  forgotPasswordEditEmail,
} = forgotPasswordSlice.actions;

export default forgotPasswordSlice.reducer;
